// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NoDataView-imageCenter-BBKdu {
    margin-inline: auto;
}

.NoDataView-commonWidth-TbpZh {
    width: 100%;
    max-width: 600px;
}

@media screen and (max-width:767px) {
    .NoDataView-contentSection-W8ykL {
        max-width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/NoDataView/NoDataView.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ","sourcesContent":[".imageCenter {\n    margin-inline: auto;\n}\n\n.commonWidth {\n    width: 100%;\n    max-width: 600px;\n}\n\n@media screen and (max-width:767px) {\n    .contentSection {\n        max-width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"imageCenter": `NoDataView-imageCenter-BBKdu`,
	"commonWidth": `NoDataView-commonWidth-TbpZh`,
	"contentSection": `NoDataView-contentSection-W8ykL`
};
module.exports = ___CSS_LOADER_EXPORT___;
